import classNames from 'classnames';

const {fromEntries, entries} = Object;
const {isArray} = Array;

export const styles = <T extends Record<string, any>>(styleObject: T) => {
    return fromEntries(
        entries(styleObject).map(([className, classList]) => [
            className,
            isArray(classList) ? classList.join(' ') : classList,
        ])
    ) as {
        [K in keyof T]: T[K] extends string[] ? string : T[K];
    };
};

export const cn = classNames;

export {cva} from 'cva';
